export default __webpack_public_path__ + "static/media/inflammation@3x.31161e83.jpg";